import * as d3 from 'd3'
import Stats from './vendor/three/Stats'

const statsVisible = false
let stats

function Loop(gl, controls) {
    this.gl = gl
    this.controls = controls
    this.state = {
        activeCount: 0,
    }
}

if (statsVisible) {
    stats = new Stats()
    // stats.setMode(1);
    document.body.appendChild(stats.domElement)
    d3.select('#stats')
        .style('position', 'fixed')
        .style('top', 0)
        .style('left', 0)
}

Loop.prototype.start = function start() {
    const that = this

    function animate() {
        if (that.state.activeCount > 0) {
            requestAnimationFrame(animate)
        }
        if (stats) {
            stats.begin()
        }

        that.controls.update()

        that.gl.tick()

        if (stats) {
            stats.end()
        }
    }

    this.state.activeCount += 1

    if (this.state.activeCount === 1) {
        animate()
    }

    return this
}

Loop.prototype.stop = function stop() {
    this.state.activeCount -= 1

    return this
}

export default Loop
